/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Mixdown_ProgressInputs */



/**
* | output |
* | --- |
* | "Audio mixdown in progress... {timecode}" |
*
* @param {Audio_Description_Export_Status_Mixdown_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixdown_progress = /** @type {((inputs: Audio_Description_Export_Status_Mixdown_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixdown_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Mixdown en cours... ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiomixdown läuft... ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Mixaggio audio in corso... ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ведется сведение звука... ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Mezcla de audio en progreso... ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频混音进行中……${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオミックスダウン進行中... ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो मिक्सडाउन जारी है... ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Mixagem de áudio em andamento... ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Audio mixdown in progress... ${i?.timecode}`)
});